import React, { useEffect, useRef, useState } from 'react';

const LocalKrpano = ({selectedDistrict}) => {
  const containerRef = useRef(null);
  const [krpanoLoaded, setKrpanoLoaded] = useState(false); // 상태 추가: KRPano 로드 여부
  const [container, setContainer] = useState(null);
 
  useEffect(() => {
    // Ensure KRPano script is loaded
    if (window.embedpano) {
      try {
        window.embedpano({
          swf: null, // Flash 지원 중단
          xml: `/krpano/${selectedDistrict}.xml`,
          target: containerRef.current, // 렌더링할 DOM 요소
          html5: 'only', // HTML5만 사용
          width: '100%', // 뷰어의 가로 크기
          height: '100%', // 뷰어의 세로 크기
        });
        setKrpanoLoaded(true); // 로딩 성공
      } catch (error) {
        console.error('Failed to load KRPano:', error);
        setKrpanoLoaded(false); // 로딩 실패
      }
    } else {
      console.error('KRPano embedpano function not found. Ensure krpano.js is loaded.');
      setKrpanoLoaded(false); // embedpano 함수 없음
    }

    // Cleanup function to remove KRPano instance
    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
    };
  }, [selectedDistrict]);

  return (
    <>
      {krpanoLoaded ? (
        <div
          ref={containerRef}
          style={{ width: '100%', height: '70vh', position: 'relative' }}
        />
      ) : (
        <div
          style={{
            width: '100%',
            height: '60vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#f8f9fa',
            color: '#6c757d',
            fontSize: '1.2rem',
            border: '1px solid #dee2e6',
            position: 'relative'
          }}
        >
          데이터가 없습니다. KRPano를 로드할 수 없습니다.
        </div>
      )}
    </>
  );
};

export default LocalKrpano;
